export default __webpack_public_path__ + "static/media/view.c46a9bff.svg";